module.exports = __webpack_public_path__ + "img/first-layer-1.ee25e433.png";